import React from 'react';
import { ScienceAssociation6to82026 } from '../views';
const BlogNewsroomPage = () => {

return <ScienceAssociation6to82026/>
};

export default BlogNewsroomPage;